import React, { useState, useEffect, useMemo } from 'react';
import Header from '../../components/ui/Header';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import HeroBanner from './components/HeroBanner';
import CategoryFilter from './components/CategoryFilter';
import SortDropdown from './components/SortDropdown';
import NewArrivalsGrid from './components/NewArrivalsGrid';
import SearchBar from './components/SearchBar';

const NewArrivalsShowcase = () => {
  const [filters, setFilters] = useState({ category: 'all' });
  const [sortBy, setSortBy] = useState('arrival-date');
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(false);

  // Mock new arrivals data with arrival dates
  const newArrivals = [
     {
      id: 1,
      name: "K.L: Trainers. Z.G.",
      category: "shoes",
      brand: "nike",
      price: 150.00,
      originalPrice: 180.00,
      image1: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=400&h=400&fit=crop",
      image:"/assets/images/shoeskl.jpg",
      description: "Comfortable running shoes with excellent cushioning and modern design perfect for daily wear.",
      isNew: true,
      discount1: 17,
      rating: 4.5,
      reviews: 128,
      sizes1: ["7", "8", "9", "10", "11", "12"],
      colors: ["black", "white", "blue"],
      arrivalDate: "2025-08-28",
      featured: true
    },
    {
      id: 2,
      name: "K.L: Trainers. Z.G.",
      category: "shoes",
      brand: "adidas",
      price: 180.00,
      isNew: true,
      image1: "https://images.unsplash.com/photo-1608231387042-66d1773070a5?w=400&h=400&fit=crop",
      image: "/assets/images/shoesklbalck.jpg",
      description: "Premium running shoes with responsive cushioning and energy return technology.",
      rating: 4.7,
      reviews: 95,
      sizes: ["7", "8", "9", "10", "11"],
      colors: ["black", "white"],
       arrivalDate: "2025-08-30",
      featured: true
    },
    {
      id: 3,
      name: "Classic Denim Jacket",
      category: "clothes",
      brand: "levi",
      price: 89.99,
      originalPrice: 120.00,
     image: "/assets/images/jacket.jpg",
      description: "Timeless denim jacket made from premium cotton with classic fit and vintage wash.",
      discount: 25,
      rating: 4.3,
      reviews: 67,
      sizes: ["S", "M", "L", "XL"],
      colors: ["blue", "black"],
         arrivalDate: "2025-08-30",
      featured: true
    },
    {
      id: 22,
      name: "Nike Air Max 270",
      category: "shoes",
      brand: "nike",
      price: 150.00,
      originalPrice: 180.00,
      image: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=400&h=400&fit=crop",
      description: "Comfortable running shoes with excellent cushioning and modern design perfect for daily wear.",
      isNew: true,
      discount: 17,
      rating: 4.5,
      reviews: 128,
      sizes: ["7", "8", "9", "10", "11", "12"],
      colors: ["black", "white", "blue"],
      arrivalDate: "2025-08-28",
      featured: true
    },
    {
      id: 4,
      name: "Leather Crossbody Bag",
      category: "bags",
      brand: "coach",
      price: 245.00,
      image: "https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=400&h=400&fit=crop",
      description: "Elegant leather crossbody bag with adjustable strap and multiple compartments.",
      isNew: true,
      rating: 4.8,
      reviews: 43,
      colors: ["brown", "black"],
      arrivalDate: "2025-08-29",
      featured: true
    },
    {
      id: 10,
      name: "Backpack Travel Bag",
      category: "bags",
      brand: "herschel",
      price: 89.99,
      image: "https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=400&h=400&fit=crop",
      description: "Spacious travel backpack with laptop compartment and water-resistant material.",
      isNew: true,
      rating: 4.7,
      reviews: 156,
      colors: ["black", "blue", "green"],
      arrivalDate: "2025-08-30",
      featured: false
    },
    {
      id: 13,
      name: "Premium Wool Coat",
      category: "clothes",
      brand: "zara",
      price: 189.99,
      image: "https://images.unsplash.com/photo-1434389677669-e08b4cac3105?w=400&h=400&fit=crop",
      description: "Luxurious wool coat with tailored fit, perfect for professional and casual wear.",
      isNew: true,
      rating: 4.6,
      reviews: 89,
      sizes: ["S", "M", "L", "XL"],
      colors: ["black", "navy", "camel"],
      arrivalDate: "2025-08-31",
      featured: false
    },
    {
      id: 14,
      name: "Adidas Boost Runner",
      category: "shoes",
      brand: "adidas",
      price: 160.00,
      image: "https://images.unsplash.com/photo-1608231387042-66d1773070a5?w=400&h=400&fit=crop",
      description: "Next-generation running shoes with responsive Boost technology and breathable upper.",
      isNew: true,
      rating: 4.9,
      reviews: 234,
      sizes: ["7", "8", "9", "10", "11", "12"],
      colors: ["white", "black", "gray"],
      arrivalDate: "2025-08-27",
      featured: true
    },
    {
      id: 15,
      name: "Designer Tote Bag",
      category: "bags",
      brand: "michael-kors",
      price: 195.00,
      originalPrice: 250.00,
      image: "https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=400&h=400&fit=crop",
      description: "Sophisticated tote bag crafted from genuine leather with gold-tone hardware.",
      isNew: true,
      discount: 22,
      rating: 4.5,
      reviews: 67,
      colors: ["black", "brown", "white"],
      arrivalDate: "2025-08-26",
      featured: false
    },
    {
      id: 16,
      name: "Casual Blazer Jacket",
      category: "clothes",
      brand: "hugo-boss",
      price: 299.99,
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop",
      description: "Versatile blazer perfect for business casual and smart casual occasions.",
      isNew: true,
      rating: 4.7,
      reviews: 145,
      sizes: ["S", "M", "L", "XL", "XXL"],
      colors: ["navy", "black", "gray"],
      arrivalDate: "2025-08-25",
      featured: true
    },
    {
      id: 17,
      name: "Jordan Air Retro",
      category: "shoes",
      brand: "jordan",
      price: 190.00,
      image: "https://images.unsplash.com/photo-1595950653106-6c9ebd614d3a?w=400&h=400&fit=crop",
      description: "Iconic basketball-inspired sneakers with premium materials and classic design.",
      isNew: true,
      rating: 4.8,
      reviews: 312,
      sizes: ["7", "8", "9", "10", "11", "12", "13"],
      colors: ["red", "black", "white"],
      arrivalDate: "2025-08-24",
      featured: false
    }
  ];

  // Filter and sort new arrivals
  const filteredAndSortedProducts = useMemo(() => {
    let filtered = [...newArrivals];

    // Filter by category
    if (filters?.category && filters?.category !== 'all') {
      filtered = filtered?.filter(product => product?.category === filters?.category);
    }

    // Filter by search query
    if (searchQuery) {
      filtered = filtered?.filter(product =>
        product?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
        product?.description?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
        product?.brand?.toLowerCase()?.includes(searchQuery?.toLowerCase())
      );
    }

    // Sort products
    switch (sortBy) {
      case 'arrival-date':
        filtered?.sort((a, b) => new Date(b?.arrivalDate) - new Date(a?.arrivalDate));
        break;
      case 'popularity':
        filtered?.sort((a, b) => (b?.reviews || 0) - (a?.reviews || 0));
        break;
      case 'price-low':
        filtered?.sort((a, b) => a?.price - b?.price);
        break;
      case 'price-high':
        filtered?.sort((a, b) => b?.price - a?.price);
        break;
      case 'rating':
        filtered?.sort((a, b) => (b?.rating || 0) - (a?.rating || 0));
        break;
      case 'name-az':
        filtered?.sort((a, b) => a?.name?.localeCompare(b?.name));
        break;
      default:
        break;
    }

    return filtered;
  }, [newArrivals, filters, searchQuery, sortBy]);

  const featuredProducts = newArrivals?.filter(product => product?.featured);

  const handleSearchSubmit = (query) => {
    setSearchQuery(query);
  };

  const handleCategoryFilter = (category) => {
    setFilters({ ...filters, category });
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="pt-16">
        {/* Hero Banner Section */}
        <HeroBanner featuredProducts={featuredProducts} />

        {/* Main Content */}
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          {/* Page Header */}
          <div className="py-12">
            <div className="text-center mb-8">
              <h1 className="text-4xl font-bold text-foreground mb-4">
                New Arrivals
              </h1>
              <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
                Discover the latest fashion trends and must-have items from top brands. 
                Be the first to get your hands on our newest collection.
              </p>
            </div>

            {/* Category Filter Tabs */}
            <CategoryFilter
              activeCategory={filters?.category}
              onCategoryChange={handleCategoryFilter}
            />

            {/* Search and Sort Controls */}
            <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4 mt-8 mb-6">
              <div className="flex-1 max-w-md">
                <SearchBar
                  searchQuery={searchQuery}
                  onSearchChange={setSearchQuery}
                  onSearchSubmit={handleSearchSubmit}
                  placeholder="Search new arrivals..."
                />
              </div>

              <div className="flex items-center gap-4">
                <SortDropdown
                  sortBy={sortBy}
                  onSortChange={setSortBy}
                />
              </div>
            </div>

            {/* Results Summary */}
            <div className="flex items-center justify-between mb-8">
              <p className="text-sm text-muted-foreground">
                Showing {filteredAndSortedProducts?.length} new arrivals
                {searchQuery && (
                  <span> for "{searchQuery}"</span>
                )}
              </p>

              {/* View Toggle */}
              <div className="flex items-center space-x-1 bg-muted rounded-lg p-1">
                <Button
                  variant="ghost"
                  size="icon"
                  className="h-8 w-8 bg-background shadow-sm"
                >
                  <Icon name="Grid3X3" size={16} />
                </Button>
                <Button
                  variant="ghost"
                  size="icon"
                  className="h-8 w-8"
                >
                  <Icon name="List" size={16} />
                </Button>
              </div>
            </div>

            {/* Products Grid */}
            <NewArrivalsGrid
              products={filteredAndSortedProducts}
              loading={loading}
            />

            {/* Load More */}
            {filteredAndSortedProducts?.length > 0 && (
              <div className="flex justify-center mt-12">
                <Button
                  variant="outline"
                  size="lg"
                  iconName="ChevronDown"
                  iconPosition="right"
                >
                  Load More Arrivals
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-card border-t border-border">
        <div className="max-w-7xl mx-auto px-6 py-12">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center space-x-2 mb-4">
                <div className="w-8 h-8 bg-accent rounded-lg flex items-center justify-center">
                  <Icon name="Footprints" size={20} color="var(--color-accent-foreground)" />
                </div>
                <span className="text-xl font-semibold text-primary">ShoeStyle</span>
              </div>
              <p className="text-sm text-muted-foreground">
                Your premier destination for fashion-forward shoes, clothes, and bags.
              </p>
            </div>
            
            <div>
              <h3 className="font-semibold text-foreground mb-3">Shop</h3>
              <ul className="space-y-2 text-sm text-muted-foreground">
                <li><a href="#" className="hover:text-foreground">New Arrivals</a></li>
                <li><a href="#" className="hover:text-foreground">Best Sellers</a></li>
                <li><a href="#" className="hover:text-foreground">Sale</a></li>
                <li><a href="#" className="hover:text-foreground">Gift Cards</a></li>
              </ul>
            </div>
            
            <div>
              <h3 className="font-semibold text-foreground mb-3">Support</h3>
              <ul className="space-y-2 text-sm text-muted-foreground">
                <li><a href="#" className="hover:text-foreground">Contact Us</a></li>
                <li><a href="#" className="hover:text-foreground">Size Guide</a></li>
                <li><a href="#" className="hover:text-foreground">Returns</a></li>
                <li><a href="#" className="hover:text-foreground">FAQ</a></li>
              </ul>
            </div>
            
            <div>
              <h3 className="font-semibold text-foreground mb-3">Connect</h3>
              <div className="flex space-x-3">
                <Button variant="ghost" size="icon">
                  <Icon name="Facebook" size={20} />
                </Button>
                <Button variant="ghost" size="icon">
                  <Icon name="Twitter" size={20} />
                </Button>
                <Button variant="ghost" size="icon">
                  <Icon name="Instagram" size={20} />
                </Button>
              </div>
            </div>
          </div>
          
          <div className="border-t border-border mt-8 pt-8 text-center">
            <p className="text-sm text-muted-foreground">
              © {new Date()?.getFullYear()} ShoeStyle Commerce. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default NewArrivalsShowcase;